import { render, staticRenderFns } from "./deleteConfirmation.vue?vue&type=template&id=66ef39a8&scoped=true&"
import script from "./deleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./deleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef39a8",
  null
  
)

export default component.exports